/* ============
 * The initial state of the alert module.
 * ============
 */
export default {
  alerts: [],
  alert: {},
  totalCount: 0,
  alertCount: [],
  resolvedNotes: [],
  alertsLoading: false,
  isResolutionLoading: false,
  errorMessage: '',
  resolvedAlertId: '',
};
